<template>
  <div class="tabs">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作流</el-breadcrumb-item>
          <el-breadcrumb-item>选项卡</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div class="refresh">
        <img :class="isRefresh ?'imgmove':''" width="16px" height="16px" src="@/assets/house/refresh.png" alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>选项卡</h4>
        
      </div>

      <div class="tabsbody">
        <el-tabs type="border-card">
          <el-tab-pane label="用户认证审核">
            <div style="height:650px;">
              用户认证审核1
            </div>
          </el-tab-pane>
          <el-tab-pane label="用户认证审核">
            <div style="height:650px;">
              用户认证审核2
            </div>
          </el-tab-pane>
          <el-tab-pane label="角色管理">
            <div style="height:650px;">
              用户认证审核3
            </div>
          </el-tab-pane>
          <el-tab-pane label="定时任务补偿">
            <div style="height:650px;">
              用户认证审核4
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getDate,formatConversion } from "@/plugins/getdate";

export default {

  data() {
    return {
      isRefresh:false
    };
  },
  methods: {
    
  },
  created() {

  },
  beforeDestroy(){ 
     
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./tabs.scss";
/deep/ .el-tabs__nav .is-active{
  font-weight: bolder;
}
</style>
